// Modules
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Styles
import styles from './SuccessHeader.module.scss';

const SuccessHeader = (props) => {
  const { total = '', heading = '', children } = props;

  return (
    <div className={styles.header}>
      <span className={styles.icon}>
        <FontAwesomeIcon icon={'check-circle'} />
      </span>

      {total ? (
        <>
          <h3>Payment successful</h3>

          <p>{`Your invoice for $${total} has been paid.`}</p>
        </>
      ) : (
        <h3>{heading ? heading : 'Payment complete'}</h3>
      )}

      {children}
    </div>
  );
};

export default SuccessHeader;
